export const colors = {
    primary: '#038787',
    orange: '#ff8900',
    secondary: '#feaa31',
    notice: '#fc2569',
    border: '#2B3433',
    background: '#0f0f33',
    yellow: '#ffbf61',
    gray: '#4e5461',
    blackText: '#1a202c',
    white: '#fff',
    black: '#000',
    bgDark: '#2B3433',
    darkPrimary: '#038787',
    red: '#fc2569',
};
